import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ForgotPasswordForm from '@/components/ForgotPasswordForm';
const ForgotPassword = () => {
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-chrona-background">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <Link to="/">
            <img alt="CHRONA" src="/lovable-uploads/dfc64acd-e312-44ad-9a99-c99e727300e4.png" className="h-28 w-auto" />
          </Link>
        </div>
        
        <div className="rounded-lg shadow-xl p-6 md:p-8 bg-[chrona-gray-200] bg-chrona-background">
          <div className="mb-6">
            <Link to="/login" className="text-chrona-gray-300 hover:text-chrona-text flex items-center">
              <ArrowLeft className="mr-2 h-4 w-4" /> Zurück zum Login
            </Link>
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-6 text-center">Passwort zurücksetzen</h1>
          
          <ForgotPasswordForm />
        </div>

        <div className="mt-8 text-center">
          <p className="text-chrona-gray-300 text-sm">
            Die einfachste Art, <span className="text-[#2C6E49]">Termine zu buchen</span>
          </p>
        </div>
      </div>
    </div>;
};
export default ForgotPassword;